import {KTUtil} from "./util.js";

export const KTApp = function () {
    const initTooltip = function (el) {
        const skin = el.data('skin') ? 'tooltip-' + el.data('skin') : '';
        const width = el.data('width') === 'auto' ? 'tooltop-auto-width' : '';
        const triggerValue = el.data('trigger') ? el.data('trigger') : 'hover';

        el.tooltip({
            trigger: triggerValue,
            template: '<div class="tooltip ' + skin + ' ' + width + '" role="tooltip">\
                <div class="arrow"></div>\
                <div class="tooltip-inner"></div>\
            </div>'
        });
    };

    const initTooltips = function () {
        $('[data-toggle="kt-tooltip"]').each(function () {
            initTooltip($(this));
        });
    };

    const initPopover = function (el) {
        const skin = el.data('skin') ? 'popover-' + el.data('skin') : '';
        const triggerValue = el.data('trigger') ? el.data('trigger') : 'hover';

        el.popover({
            trigger: triggerValue,
            template: `
                <div class="popover ${skin}" role="tooltip">
                    <div class="arrow"></div>
                    <h3 class="popover-header"></h3>
                    <div class="popover-body"></div>
                </div>
            `
        });
    };

    const initPopovers = function () {
        $('[data-toggle="kt-popover"]').each(function () {
            initPopover($(this));
        });
    };

    const initFileInput = function () {
        $('.custom-file-input').on('change', function () {
            const fileName = $(this).val();

            $(this).next('.custom-file-label').addClass("selected").html(fileName);
        });
    };

    const initScroll = function () {
        $('[data-scroll="true"]').each(function () {
            const el = $(this);

            KTUtil.scrollInit(this, {
                mobileNativeScroll: true,
                handleWindowResize: true,
                rememberPosition: el.data('remember-position') == 'true',
                height: function () {
                    if (KTUtil.isInResponsiveRange('tablet-and-mobile') && el.data('mobile-height')) {
                        return el.data('mobile-height');
                    } else {
                        return el.data('height');
                    }
                }
            });
        });
    };

    const initAlerts = function () {
        $('body').on('click', '[data-close=alert]', function () {
            $(this).closest('.alert').hide();
        });
    };

    const initAbsoluteDropdowns = function () {
        $('body').on('show.bs.dropdown', function (e) {
            const $toggler = $(e.target).find("[data-attach='body']");
            if ($toggler.length === 0) {
                return;
            }
            const $dropdownMenu = $(e.target).find('.dropdown-menu');
            const $detachedDropdownMenu = $dropdownMenu.detach();
            $toggler.data('dropdown-menu', $detachedDropdownMenu);

            $('body').append($detachedDropdownMenu);
            $detachedDropdownMenu.css('display', 'block');
            $detachedDropdownMenu.position({
                my: 'right top',
                at: 'right bottom',
                of: $(e.relatedTarget),
            });
        });

        $('body').on('hide.bs.dropdown', function (e) {
            const $toggler = $(e.target).find("[data-attach='body']");

            if ($toggler.length === 0) {
                return;
            }

            const $detachedDropdownMenu = $toggler.data('dropdown-menu');

            $(e.target).append($detachedDropdownMenu.detach());
            $detachedDropdownMenu.hide();
        });
    };

    return {
        init: function () {
            KTApp.initComponents();
        },

        initComponents: function () {
            initScroll();
            initTooltips();
            initPopovers();
            initAlerts();
            initFileInput();
            initAbsoluteDropdowns();
        },

        block: function (target, options) {
            let el = $(target);

            options = $.extend(true, {
                opacity: 0.05,
                overlayColor: '#000000',
                type: '',
                size: '',
                state: 'brand',
                centerX: true,
                centerY: true,
                message: '',
                shadow: true,
                width: 'auto'
            }, options);

            let html;
            const version = options.type ? 'kt-spinner--' + options.type : '';
            const state = options.state ? 'kt-spinner--' + options.state : '';
            const size = options.size ? 'kt-spinner--' + options.size : '';
            const spinner = '<div class="kt-spinner ' + version + ' ' + state + ' ' + size + '"></div';

            if (options.message && options.message.length > 0) {
                const classes = 'blockui ' + (options.shadow === false ? 'blockui' : '');

                html = '<div class="' + classes + '"><span>' + options.message + '</span><span>' + spinner + '</span></div>';

                el = document.createElement('div');
                KTUtil.get('body').prepend(el);
                KTUtil.addClass(el, classes);
                el.innerHTML = '<span>' + options.message + '</span><span>' + spinner + '</span>';
                options.width = KTUtil.actualWidth(el) + 10;
                KTUtil.remove(el);

                if (target === 'body') {
                    html = '<div class="' + classes + '" style="margin-left:-' + (options.width / 2) + 'px;"><span>' + options.message + '</span><span>' + spinner + '</span></div>';
                }
            } else {
                html = spinner;
            }

            const params = {
                message: html,
                centerY: options.centerY,
                centerX: options.centerX,
                css: {
                    top: '30%',
                    left: '50%',
                    border: '0',
                    padding: '0',
                    backgroundColor: 'none',
                    width: options.width
                },
                overlayCSS: {
                    backgroundColor: options.overlayColor,
                    opacity: options.opacity,
                    cursor: 'wait',
                    zIndex: (target === 'body' ? 1100 : 10)
                }
            };

            if (target === 'body') {
                params.css.top = '50%';
            } else {
                el = $(target);
                el.block(params);
            }
        }
    };
}();

export {}
